import React from "react";

import Modal from "../../../components/Modal";
import Button from "../../../components/Button";
import DocumentProblem from "./DocumentProblem";

/**
 * Detalhes do que impediu a nota de ser autorizada (BDM-887).
 *
 * A lista mostra só a situação; o motivo mora aqui porque não cabe na
 * coluna. Junto com a explicação em português vai a mensagem original do
 * fisco/serviço fiscal — é o que o usuário repassa ao suporte ou à
 * contabilidade quando a tradução não basta.
 */
export const ModalDocumentProblem = ({ document, close }) => {
    const problem = document?.friendly_problem;
    // A mensagem original só entra quando diz algo a mais: comparar por
    // diferença faria o bloco aparecer só porque o dicionário aparou o eco
    // do título — repetindo na tela o texto que ele tirou.
    const raw = problem?.raw && !problem.raw.includes(problem.message) ? problem.raw : null;

    return (
        <Modal
            show={document !== null && !!problem}
            close={close}
            title={`Por que a nota não foi emitida`}
            footer={<Button type={`secondary`} size={`small`} text={`Fechar`} action={close} />}
        >
            <div className="section">
                {document?.number &&
                    <p className={`fiscal-hint`}>Nota nº {document.number}</p>
                }

                <DocumentProblem problem={problem} />

                {raw &&
                    <div className={`fiscal-problem-raw`}>
                        <span>Mensagem original</span>
                        <p>{raw}</p>
                    </div>
                }
            </div>
        </Modal>
    );
};

export default ModalDocumentProblem;
